export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9777.d33df8e7.jpg";